"use strict";
exports.__esModule = true;
//# sourceMappingURL=document-investor.js.map